export const ExteriorImages = [
    {
        original: 'https://i.ibb.co/k8dmzWM/IMG-20210701-201922.jpg',
        thumbnail: 'https://i.ibb.co/QN5Dh1X/IMG-20210701-201922.jpg',
    },
    {
        original: 'https://i.ibb.co/JdWYn06/IMG-20210703-141108.jpg',
        thumbnail: 'https://i.ibb.co/j59ChB0/IMG-20210703-141108.jpg',
    },
    {
        original: 'https://i.ibb.co/CsQpg2b/IMG-20210701-202056.jpg',
        thumbnail: 'https://i.ibb.co/Xktf187/IMG-20210701-202056.jpg',
    },
    {
        original: 'https://i.ibb.co/wKQPdgS/IMG-20210703-141212.jpg',
        thumbnail: 'https://i.ibb.co/P5WPrjc/IMG-20210703-141212.jpg',
    },
    {
        original: 'https://i.ibb.co/Thkvjxz/IMG-20210703-140622.jpg',
        thumbnail: 'https://i.ibb.co/vzHwy62/IMG-20210703-140622.jpg',
    },
];